import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { ArrowLeft } from "lucide-react";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md text-center">
        <p className="text-[13px] font-medium text-muted-foreground mb-2">404</p>
        <h1 className="text-2xl font-semibold text-foreground mb-2">Page not found</h1>
        <p className="text-[14px] text-muted-foreground mb-6">
          The page you're looking for doesn't exist. It may have been moved or the address was mistyped.
        </p>
        <Button variant="outline" onClick={() => navigate("/workspaces")}>
          <ArrowLeft className="mr-1.5 h-3.5 w-3.5" />
          Back to home
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
